import React from 'react';

// DEPENDENCIES
import pick from 'lodash/pick';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// CORE COMPONENTS
import Form from 'core/form/Form';

// PARTS
import Card from 'parts/card/Card';
import Record from 'parts/record/Record.js';
import EmailForm from 'parts/report/tools/EmailForm';

// FUNCTIONS
const formatRecord = record => pick(record, [
  'day_of_month',
  'day_of_week',
  'email_body',
  'email_to',
  'email_subject',
  'is_active',
  'is_for_wholesale',
  'new_used',
  'report_email_attachment_type_id',
  'report_email_frequency_id',
  'report_email_daterange_id',
  'report_email_id',
  'report_id',
])

// MAIN COMPONENT
const ReportCategoryUpdate = () => (
  <Record.Update
    recordLabel="Email Report"
    method="POST"
    endpoints={ENDPOINTS.admin.reports.email}
    formatRecord={formatRecord}
    deleteButton={false}
  >
    <Card body={<EmailForm as={Form.Body} />} />
  </Record.Update>
);

// EXPORT
export default ReportCategoryUpdate;
